const colorMap = {
  primary: "bg-primary/10 text-primary border-primary/20",
  accent:  "bg-cyan-500/10 text-cyan-600 dark:text-cyan-400 border-cyan-400/20",
  gold:    "bg-amber-400/10 text-amber-600 dark:text-amber-400 border-amber-400/20",
  green:   "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-400/20",
  amber:   "bg-orange-400/10 text-orange-600 dark:text-orange-400 border-orange-400/20",
  red:     "bg-red-500/10 text-red-600 dark:text-red-400 border-red-400/20",
};

export default function StatsCard({ icon, label, value, color = "primary" }) {
  return (
    <div className={`rounded-2xl p-4 border ${colorMap[color]} flex flex-col gap-2`}>
      <div className="flex items-start justify-between">
        <span className="text-xl">{icon}</span>
        <span className="text-xl font-black leading-tight">{value}</span>
      </div>
      <p className="text-xs font-semibold opacity-80 leading-snug">{label}</p>
    </div>
  );
}